import { createAction } from 'redux-actions';
import { EmployerEvent, RecruiterEvent } from 'types/pusher';
import { Notification } from 'types/notifications';

export interface PusherEventPayload {
  event: EmployerEvent | RecruiterEvent;
  data: Notification;
}

export const pusherEvent = createAction<PusherEventPayload>('PUSHER_EVENT');
